// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Banner__heading:not(:last-child){margin-bottom:1.5rem}.Banner__copy:not(:last-child){margin-bottom:3rem}.Banner__copy b,.Banner__heading b{font:inherit}@media (min-width: 1000px){.Banner__heading--wrap{max-width:40%}}.Banner--black{color:#1A1A1A}.Banner--white{color:#FFFFFF}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
